import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table view.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table component
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'edit', // Column ID for edit action
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template for rendering edit icon
                                        if (!devConfig.getPermAction('TemplateEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon if no permission
                                        } else {
                                            return ''; // Return empty if permission exists
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail action
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip for details
                                    template: function (obj) {
                                        // Template for rendering details icon
                                        return "<span class='webix_icon wxi-close details'></span>"; // Return details icon
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: _('ID'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID for Type
                                    header: _('Tipo'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Language', // Column ID for Language
                                    header: _('Idioma'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Section', // Column ID for Section
                                    header: _('Sección'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click actions
                                details: function (euv, id) {
                                    // Handler for details icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.show(
                                        '../partner.templates.smsTemplate?id=' + item.Id, // Show details view
                                    );
                                },
                                edit: function (euv, id) {
                                    // Handler for edit icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    $$('editTemplate').show(); // Show edit template window
                                    $$('editform').setValues(item); // Set values in edit form
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            autoConfig: false, // Disable auto configuration
                            pager: 'pagerA', // Pager ID for pagination
                            on: {
                                // Event handlers for datatable
                                onItemDblClick: (id) => {}, // Double click handler (empty)
                                onBeforeLoad: function () {
                                    // Before load event
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // After load event
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Ready event for datatable
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data overlay
                                            '</div>',
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        var url = devConfig.geturlApi() + 'Partners/GetTemplateSMSList'; // API URL for fetching templates
        var filter = ''; // Filter string for API requests
        grid.showOverlay(
            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                _('No hay datos') + // Show no data overlay
                '</div>',
        );
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        // Event listener for filter changes
        this.on(this.app, 'filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        if (object[i][1] !== ' ') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                            string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                        }
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
            ).then(function (data) {
                data = data.json(); // Parse JSON response
                if (!data.HasError) {
                    // Check for errors in response
                    if (data.Data.length > 0) {
                        // Check if data exists
                        this.hideOverlay(); // Hide no data overlay
                    } else {
                        grid.clearAll(); // Clear grid if no data
                        grid.showOverlay(
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                _('No hay datos') + // Show no data overlay
                                '</div>',
                        );
                    }
                } else {
                    grid.clearAll(); // Clear grid on error
                    grid.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Show no data overlay
                            '</div>',
                    );
                    webix.message({
                        // Show error message
                        title: _('¡Error!'),
                        type: 'alert-error',
                        text: _('Ocurrio un error, comuniquese con soporte'),
                    });
                }
            });
            filter = string1; // Update filter variable
        });

        var datePopup = []; // Array to hold date options for popup
        var popup = ''; // Variable for add template popup
        var popupAdd = ''; // Variable for edit template popup
        const params = {
            Partner: id_partner, // Parameters for API request
        };

        // AJAX request to fetch section templates
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Partners/GetSectionTemplateSMSSelect', params, {
                error: function (text, data, XmlHttpRequest) {
                    // Error handler
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handler
                    var resp = JSON.parse(text); // Parse response
                    if (!resp.HasError) {
                        // Check for errors
                        datePopup = resp.Data; // Store date options
                        popupAdd = webix.ui({
                            // Create add template popup
                            view: 'window',
                            id: 'AddProviders', // Unique ID for the popup
                            width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                            height: screen.width < 500 ? 600 : 250, // Set height based on screen size
                            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                            head: {
                                view: 'toolbar', // Toolbar for popup header
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Añadir Plantilla'), // Label for add template
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide popup on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center position for popup
                            modal: true, // Modal popup
                            body: {
                                view: 'scrollview', // Scrollable view for body
                                scroll: 'y', // Vertical scrolling
                                body: {
                                    view: 'form', // Form for adding template
                                    id: 'addform', // Unique ID for the form
                                    width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                                    height: screen.width < 500 ? 600 : 200, // Set height based on screen size
                                    elements: [
                                        {
                                            view: 'text', // Text input for Type
                                            label: _('Tipo'), // Label for Type
                                            name: 'Type', // Name for input
                                            required: true, // Required field
                                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            view: 'combo', // Combo box for Language
                                            label: _('Idioma'), // Label for Language
                                            name: 'Language', // Name for input
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                            options: [
                                                // Options for language selection
                                                {
                                                    id: 'es',
                                                    value: 'español (o castellano) (ES)', // Spanish option
                                                },
                                                {
                                                    id: 'en',
                                                    value: 'English (EN)', // English option
                                                },
                                            ],
                                        },
                                        {
                                            view: 'combo', // Combo box for Section
                                            label: _('Sección'), // Label for Section
                                            name: 'Section', // Name for input
                                            options: datePopup, // Options from API response
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            cols: [
                                                // Button row
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'), // Button label
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide popup on cancel
                                                        $$('addform').setValues(
                                                            $$('addform').getCleanValues(), // Reset form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form', // Button type
                                                    value: _('Guardar'), // Button label
                                                    click: function ($e) {
                                                        // Click handler for save button
                                                        var values = $$('addform').getValues(); // Get form values
                                                        values.Partner = id_partner; // Add partner ID to values
                                                        if (
                                                            $$('addform').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                        'Partners/AddTemplateSMSList', // API URL for adding template
                                                                    values, // Send form values
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            // Error handler
                                                                            webix.message({
                                                                                title: _(
                                                                                    '¡Error!', // Error title
                                                                                ),
                                                                                type: 'alert-error', // Error type
                                                                                text: _(
                                                                                    'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                ),
                                                                            });
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            // Success handler
                                                                            var response = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            if (
                                                                                !response.HasError // Check for errors
                                                                            ) {
                                                                                webix.message(
                                                                                    'Tipo de plantilla agregada satisfactoriamente.', // Success message
                                                                                );
                                                                                grid.clearAll(); // Clear grid
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        grid.data.$pagesize +
                                                                                        filter, // Reload grid data
                                                                                );
                                                                            } else {
                                                                                webix.message({
                                                                                    title: _(
                                                                                        '¡Error!', // Error title
                                                                                    ),
                                                                                    type: 'alert-error', // Error type
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            $$('addform').setValues(
                                                                $$('addform').getCleanValues(), // Reset form values
                                                            );
                                                            this.getTopParentView().hide(); // Hide popup
                                                        } else {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error title
                                                                ),
                                                                type: 'alert-error', // Error type
                                                                text: _(
                                                                    'Completa los campos...', // Error message
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate on change
                                            },
                                        },
                                    },
                                },
                            },
                        });
                        popup = webix.ui({
                            // Create edit template popup
                            view: 'window',
                            id: 'editTemplate', // Unique ID for the popup
                            width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                            height: screen.width < 500 ? 600 : 350, // Set height based on screen size
                            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                            head: {
                                view: 'toolbar', // Toolbar for popup header
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Editar Plantilla'), // Label for edit template
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide popup on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center position for popup
                            modal: true, // Modal popup
                            body: {
                                view: 'scrollview', // Scrollable view for body
                                scroll: 'y', // Vertical scrolling
                                body: {
                                    view: 'form', // Form for editing template
                                    id: 'editform', // Unique ID for the form
                                    width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                                    height: screen.width < 500 ? 600 : 250, // Set height based on screen size
                                    elements: [
                                        {
                                            view: 'text', // Text input for ID
                                            label: 'Id', // Label for ID
                                            name: 'Id', // Name for input
                                            readonly: true, // Read-only field
                                            required: true, // Required field
                                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            view: 'text', // Text input for Type
                                            label: _('Tipo'), // Label for Type
                                            name: 'Type', // Name for input
                                            readonly: false, // Editable field
                                            required: true, // Required field
                                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            view: 'combo', // Combo box for Language
                                            label: _('Idioma'), // Label for Language
                                            name: 'Language', // Name for input
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                            options: [
                                                // Options for language selection
                                                {
                                                    id: 'es',
                                                    value: 'español (o castellano) (ES)', // Spanish option
                                                },
                                                {
                                                    id: 'en',
                                                    value: 'English (EN)', // English option
                                                },
                                            ],
                                        },
                                        {
                                            view: 'combo', // Combo box for Section
                                            label: _('Sección'), // Label for Section
                                            name: 'Section', // Name for input
                                            options: datePopup, // Options from API response
                                            required: true, // Required field
                                            labelWidth: 150, // Label width
                                        },
                                        {
                                            cols: [
                                                // Button row
                                                {
                                                    view: 'button', // Cancel button
                                                    value: _('Cancelar'), // Button label
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide popup on cancel
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    type: 'form', // Button type
                                                    value: _('Guardar'), // Button label
                                                    click: function ($e) {
                                                        // Click handler for save button
                                                        var values = $$('editform').getValues(); // Get form values
                                                        values.Partner = id_partner; // Add partner ID to values
                                                        if (
                                                            $$('editform').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                        'Partners/UpdateTemplateSMSList', // API URL for updating template
                                                                    values, // Send form values
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            // Error handler
                                                                            webix.message({
                                                                                title: _(
                                                                                    '¡Error!', // Error title
                                                                                ),
                                                                                type: 'alert-error', // Error type
                                                                                text: _(
                                                                                    'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                ),
                                                                            });
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            // Success handler
                                                                            var response = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            if (
                                                                                !response.HasError // Check for errors
                                                                            ) {
                                                                                webix.message(
                                                                                    'Tipo de plantilla actualizada satisfactoriamente.', // Success message
                                                                                );
                                                                                grid.clearAll(); // Clear grid
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        grid.data.$pagesize +
                                                                                        filter, // Reload grid data
                                                                                );
                                                                            } else {
                                                                                webix.message({
                                                                                    title: _(
                                                                                        '¡Error!', // Error title
                                                                                    ),
                                                                                    type: 'alert-error', // Error type
                                                                                    text: _(
                                                                                        'Ocurrio un error, comuniquese con soporte', // Error message
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            $$('editform').setValues(
                                                                $$('editform').getCleanValues(), // Reset form values
                                                            );
                                                            this.getTopParentView().hide(); // Hide popup
                                                        } else {
                                                            webix.message({
                                                                title: _(
                                                                    '¡Error!', // Error title
                                                                ),
                                                                type: 'alert-error', // Error type
                                                                text: _(
                                                                    'Completa los campos...', // Error message
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate on change
                                            },
                                        },
                                    },
                                },
                            },
                        });
                    }
                },
            });

        // Event listener for adding template button
        this.on(this.app, 'addTemplate:button', (filter) => {
            if (datePopup.length > 0) {
                // Check if date options are available
                $$('addform').clearValidation(); // Clear validation
                popupAdd.show(); // Show add template popup
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message
                    title: _('¡Error!'), // Error title
                    type: 'alert-error', // Error type
                });
            }
        });
    }
}

// FILE DOCUMENTED
